// extracted by mini-css-extract-plugin
export var cartIcon = "_jc-0";
export var cartIconContainer = "_jc-1";